import { Button, Checkbox, Form, Input, Tabs } from 'antd'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { doLogin, registerUser } from './store/store'
import { ErrorMessage } from './ErrorMessage'
import { SuccessMessage } from './SuccessMessage'
import PasswordRecovery from './PasswordRecovery'

const { TabPane } = Tabs

function LayoutLogin() {
  const login = useSelector(state => state.login)
  const [registrationForm] = Form.useForm()

  useEffect(() => {
    if (login.registrationSuccess) {
      registrationForm.resetFields()
    }
  }, [login.registrationSuccess, registrationForm])

  return (
    <Tabs className = "form-body" defaultActiveKey="1">
      <TabPane tab="Вход" key="1">
        <div className="password-recovery-align">
          <PasswordRecovery />
        </div>
        <Form
          name="enter"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          onFinish={doLogin}
          autoComplete="off"
        >
          <Form.Item
            label="Логин"
            name="login"
            rules={[{ required: true, message: 'Введите Ваш логин' }]}
          >
            <Input autoComplete="username" />
          </Form.Item>

          <Form.Item
            label="Пароль"
            name="password"
            rules={[{ required: true, message: 'Введите пароль' }]}
          >
            <Input.Password autoComplete="current-password" />
          </Form.Item>

          <Form.Item name="remember" valuePropName="checked" wrapperCol={{ offset: 8, span: 16 }}>
            <Checkbox>Запомнить меня</Checkbox>
          </Form.Item>

          <ErrorMessage error = { login.loginError } />

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type="primary" htmlType="submit">
              Войти
            </Button>
          </Form.Item>
        </Form>
      </TabPane>
      <TabPane tab="Регистрация" key="2">
        <Form
          name="registration"
          form={registrationForm}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          onFinish={registerUser}
          autoComplete="off"
        >
          <Form.Item
            label="Логин"
            name="login"
            rules={[{ required: true, message: 'Введите Ваш логин' }]}
          >
            <Input autoComplete="username" />
          </Form.Item>

          <Form.Item
            label="Пароль"
            name="password"
            hasFeedback
            rules={[{ required: true, message: 'Введите пароль' }]}
          >
            <Input.Password autoComplete="new-password" />
          </Form.Item>

          <Form.Item
            label="Подтверждение Пароля"
            name="confirmpassword"
            dependencies={['password']}
            hasFeedback
            rules={[
              { required: true, message: 'Введите пароль еще раз для подтверждения' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve()
                  }

                  return Promise.reject(new Error('Пароли, введенные Вами, не совпадают'))
                }
              })
            ]}
          >
            <Input.Password autoComplete="new-password" />
          </Form.Item>

          <Form.Item
            label="Имя"
            name="first_name"
            rules={[{ required: true, message: 'Введите Ваше имя' }]}
          >
            <Input autoComplete="given-name" />
          </Form.Item>

          <Form.Item
            label="Фамилия"
            name="second_name"
            rules={[{ required: true, message: 'Введите Вашу фамилию' }]}
          >
            <Input autoComplete="family-name" />
          </Form.Item>

          <Form.Item
            label="Эл. Почта"
            name="email"
            rules={[
              { type: 'email', message: 'The input is not valid E-mail!' },
              { required: true, message: 'Введите адрес Вашей электронной почты' }
            ]}
          >
            <Input autoComplete="email" placeholder="example@domain.com"/>
          </Form.Item>

          <ErrorMessage error = { login.registrationError } />
          <SuccessMessage message = { login.registrationSuccess && 'Регистрация прошла успешно. Теперь Вы можете войти.' } />

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type="primary" htmlType="submit" disabled={!!login.registrationSuccess}>
              Зарегистрировать
            </Button>
          </Form.Item>
        </Form>
      </TabPane>
    </Tabs>
  );
}

export default LayoutLogin;
